import { render } from "./HistorySection.vue?vue&type=template&id=a4c1f1f0&scoped=true"
import script from "./HistorySection.vue?vue&type=script&lang=js"
export * from "./HistorySection.vue?vue&type=script&lang=js"

import "./HistorySection.vue?vue&type=style&index=0&id=a4c1f1f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c1f1f0"]])

export default __exports__